import { useAppDialog } from "../../store/app-dialog";
import { useProduct } from "../../store/product";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export const CheckoutErrorDialog = ({ message }) => {
  const product = useProduct((s) => s.product);
  const { closeDialog } = useAppDialog();

  return (
    <>
      <DialogTitle>
        Errore
      </DialogTitle>
      <DialogContent>
        {message}
      </DialogContent>
      <DialogActions>
        <Button fullWidth variant="outlined" onClick={closeDialog}>
          Chiudi
        </Button>
      </DialogActions>
    </>
  );
};
